// extracted by mini-css-extract-plugin
export var button = "InternalEvents-module--button--662b2";
export var buttonRow = "InternalEvents-module--buttonRow--1cc3d";
export var cards = "InternalEvents-module--cards--59299";
export var content = "InternalEvents-module--content--05894";
export var fadeInAnimation = "InternalEvents-module--fadeInAnimation--dca3e";
export var tags = "InternalEvents-module--tags--53496";
export var withTags = "InternalEvents-module--withTags--88fb9";
export var wrapper = "InternalEvents-module--wrapper--555df";